import type { ReactNode } from 'react';

// Types
import type { SettingsHeaderProps } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsHeader';
import { SettingsHeader } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsHeader';
import { SettingsLogout } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsLogout';
// Components
import { SettingsMenu } from '@/components/layouts/LayoutPlatform/components/SettingsWrapper/SettingsMenu';

type SettingsWrapperProps = {
    children: ReactNode;
};

const SettingsWrapper = ({ children }: SettingsWrapperProps) => {
    return (
        <div className="flex h-full w-full flex-row" data-testid="account-settings-main-content">
            <div className="scrollbar hidden h-full w-56 flex-col justify-between sm:flex">
                <SettingsMenu className="pl-6 pr-8" />
                <div className="border-t border-icoGray-300 py-3 pl-6 pr-8 dark:border-icoDarkMode-beton">
                    <SettingsLogout />
                </div>
            </div>
            <div className="scrollbar h-full flex-1 bg-white @container/settings dark:bg-icoDarkMode-deepBlack">
                <div className="flex min-h-full flex-col @2xl/settings:flex-row">{children}</div>
            </div>
        </div>
    );
};

type MainContentProps = {
    header?: SettingsHeaderProps['children'];
    children: ReactNode;
};

const MainContent = ({ header, children }: MainContentProps) => (
    <div className="w-full flex-1 p-8 @container/settings-main-content">
        <SettingsHeader>{header}</SettingsHeader>
        {children}
    </div>
);

type SideContentProps = {
    children: ReactNode;
};

const SideContent = ({ children }: SideContentProps) => (
    <div className="w-full border-t border-icoGray-300 @2xl/settings:w-72 @2xl/settings:border-l @2xl/settings:border-t-0 dark:border-icoDarkMode-beton">
        {children}
    </div>
);

SettingsWrapper.MainContent = MainContent;
SettingsWrapper.SideContent = SideContent;

export default SettingsWrapper;
